export const maxLegendEntries = 40;
export const stepsPerMagnitude = 4;
